import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import CachedIcon from "@material-ui/icons/Cached";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  formatNumber,
  isAdmin,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisReadOnly,
  isRoleTechician,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect } from "react";
import LoyaltyPointForm from "./Component/LoyaltyPointForm";
import ListLoyaltyPoints from "./ListLoyaltyPoints";
import LoyaltyPointsPopup from "./Popup/LoyaltyPointsPopup";

const LoyaltyPointsIndex = () => {
  const {
    searchLoyaltyPoints,
    handleChangeFormSearch,
    handleCloseCreateOrEditPopup,
    openFormCreateOrEdit,
    initialLoyaltyPoints,
    saveOrUpdateLoyaltyPoints,
    openConfirmDelete,
    handleOpenConfirmDelete,
    handleDeleteRewardPoint,
    handleOpenFormCreateOrEdit,
    handleSetInitialLoyaltPoint,
    resetStore,
    openConfirmMessage,
    handleCloseConfirmMessage,
    handleResetLoyaltyPoints,
    openConfirmReset,
    handleOpenConfirmReset,
    handleConfirmResetLoyaltyPoints,
  } = useStore().patientManagementStore.loyaltyPointsStore;
  const { handleGetPatientOverviewByIdNotLoading, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const defaultDepartment = useDefaultDepartment();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isReadonly = isRoleHisReadOnly();
  const isCashier = isRoleCashier();
  const isRoleSalesConsultant = isSalesConsultant();
  const hasPermission =
    isRoleCt ||
    isAdmins ||
    isRoleBranchManagers ||
    isCashier ||
    isRoleSalesConsultant;
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearch({
        ...searchLoyaltyPoints,
        patientId,
      });
    }
    return () => resetStore();
  }, [patientId, defaultDepartment]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Formik
      initialValues={searchLoyaltyPoints}
      // onSubmit={(values) => {
      //   handleChangeFormSearch({ ...values, pageIndex: 1 });
      // }}
      enableReinitialize
    >
      <Form autoComplete="off">
        <section className="cards-container">
          {isMobile && (
            <Grid container spacing={1} className="cards-body ">
              <Grid item xs={12} className="flex flex-end">
                <CommonButton
                  className="btn-add"
                  style={{ position: "relative", height: "100%" }}
                  onClick={() => handleOpenFormCreateOrEdit()}
                >
                  <Add />
                  Tích điểm
                </CommonButton>
              </Grid>
            </Grid>
          )}
          <Grid container spacing={1} className="cards-body ">
            <Grid item xs={12} className="">
              <h2 className="reward-history__title">Lịch sử tích điểm</h2>
            </Grid>
            <Grid item xs={12} className="flex flex-end">
              <Grid container spacing={1} className="patient-money-info">
                <Grid item xs={6} sm={6} md={2}>
                  <div className="field">
                    <Tooltip title="Điểm phân hạng">
                      <div className="flex align-center gap-1">
                        <label>Điểm phân hạng</label>
                        <span class="badge badge-light-blue">
                          {formatNumber(
                            initialPatient?.clientReward?.rankPoints || 0
                          )}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <div className="field">
                    <Tooltip title="Điểm tích lũy">
                      <div className="flex align-center gap-1">
                        <label>Điểm tích lũy</label>
                        <span class="badge badge-light-blue">
                          {formatNumber(
                            initialPatient?.clientReward?.pointsEarned || 0
                          )}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <div className="field">
                    <Tooltip title="Điểm đã dùng">
                      <div className="flex align-center gap-1">
                        <label>Điểm đã dùng</label>
                        <span class="badge badge-light-blue">
                          {formatNumber(
                            initialPatient?.clientReward?.pointsSpent || 0
                          )}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <div className="field">
                    <Tooltip title="Hạng khách hàng:">
                      <div className="flex align-center gap-1">
                        <label>Hạng khách hàng</label>
                        <span class="badge badge-light-blue">
                          {initialPatient?.clientReward?.ranking?.name || ""}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </Grid>

                {isAdmins && (
                  <Grid item xs={6} sm={6} md={3} className="flex flex-end">
                    <Button
                      variant="outlined"
                      type="button"
                      startIcon={
                        <CachedIcon
                          size={16}
                          style={{
                            color: "#4276a4",
                          }}
                        />
                      }
                      onClick={() => handleResetLoyaltyPoints()}
                      className="action-btn-custom"
                    >
                      {!isMobile && "Reset điểm tích lũy"}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>

            {!isMobile && (
              <Grid item xs={12} md={3} className="">
                <LoyaltyPointForm
                  initialValues={initialLoyaltyPoints}
                  handleSubmit={saveOrUpdateLoyaltyPoints}
                  handleAfterSubmit={() => {
                    handleSetInitialLoyaltPoint();
                    setTimeout(() => {
                      handleGetPatientOverviewByIdNotLoading(patientId);
                    }, 400);
                  }}
                  patient={initialPatient?.patientInfo}
                  handleSetInitial={handleSetInitialLoyaltPoint}
                  hasPermission={hasPermission}
                />
              </Grid>
            )}

            <Grid item xs={12} md={9} className="flex">
              <ListLoyaltyPoints />
            </Grid>
          </Grid>

          <LoyaltyPointsPopup
            open={openFormCreateOrEdit}
            handleClose={handleCloseCreateOrEditPopup}
            initialValues={initialLoyaltyPoints}
            handleSubmit={saveOrUpdateLoyaltyPoints}
            handleAfterSubmit={() => {
              setTimeout(() => {
                handleGetPatientOverviewByIdNotLoading(patientId);
              }, 400);
            }}
            patient={initialPatient?.patientInfo}
          />

          {openConfirmDelete && (
            <ConfirmPopup
              open={openConfirmDelete}
              onClose={() => handleOpenConfirmDelete(null)}
              text="Bạn có chắc chắn muốn hủy tích điểm này không ?"
              onConfirm={async () => {
                let data = await handleDeleteRewardPoint();
                if (data?.responseStatus !== false) {
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 400);
                }
              }}
            />
          )}
          {openConfirmReset && (
            <ConfirmPopup
              open={openConfirmReset}
              onClose={() => handleOpenConfirmReset(false)}
              text="Bạn có chắc chắn muốn reset tích điểm này không ?"
              onConfirm={async () => {
                let data = await handleConfirmResetLoyaltyPoints(patientId);
                if (data?.responseStatus !== false) {
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 400);
                }
              }}
            />
          )}
          {!!openConfirmMessage && (
            <ConfirmPopup
              open={!!openConfirmMessage}
              onClose={() => handleCloseConfirmMessage(null)}
              text={openConfirmMessage}
              hideConfirm
              textClose={"Quay lại"}
              title="Xóa tích điểm"
            />
          )}
        </section>
      </Form>
    </Formik>
  );
};

export default memo(observer(LoyaltyPointsIndex));
